function toggleModal(id) {
    var content = document.getElementById(id);
    var modalContainer = document.getElementById('references-modal');
    var bodyTag = document.getElementsByTagName("body")[0];
    
    if (modalContainer) {
        var modalContentContainer = document.getElementById('references-modal-content');

        if (modalContainer.classList.contains("hide")) {
            modalContainer.classList.remove("hide");
            bodyTag.classList.add('no-scroll');

            if (content) {
                modalContentContainer.innerHTML = "";
                modalContentContainer.innerHTML = content.innerHTML;
            }
        } else {
            modalContainer.classList.add("hide");
            bodyTag.classList.remove('no-scroll');
        }
    }
}


function toggleModalImage(tag, dir) {
    if (tag) {
        var parent = document.getElementById('ref-img-container');

        if (parent) {
            let children = parent.querySelectorAll('.ref-image');
            let currentLeft = parseInt(parent.style.left.replace("px", ""));
            let totalLeft = children.length * 100;
            var prevButton = document.getElementById('prev-button');
            var nextButton = document.getElementById('next-button');

            if (dir == 'right') {
                if (currentLeft - 100 > totalLeft * -1) {
                    parent.style.left = (currentLeft - 100) + '%';
                } 

            } else if (dir == 'left') {
                
                if (currentLeft == 0) {
                    return;
                }
                if (currentLeft + 100 < totalLeft) {
                    parent.style.left = (currentLeft + 100) + '%';
                }

            }


            var newLeft = parseInt(parent.style.left.replace("%", "").replace("px", ""));
            if (newLeft == 0) {
                prevButton.classList.add('disabled')
            } else {
                prevButton.classList.remove('disabled');
            }

            if (newLeft == (totalLeft-100) * -1) {
                nextButton.classList.add('disabled');
            } else {
                nextButton.classList.remove('disabled');
            }
        }
    }
}

window.toggleModal = toggleModal;
window.toggleModalImage = toggleModalImage;